import { MDBIcon } from "mdb-react-ui-kit";
import { useContext, useState } from "react";
import { ResumeContext } from "../../context/resume/resume-context";
import { TranslationContext } from "../../context/translations/translations-context";
import AddLanguageSkill from "./language-skills/AddLanguageSkill";
import LanguageSkillList from "./language-skills/LanguageSkillList";

export default function LanguageSkillsSection() {

    const [ isVisible, setIsVisible ] = useState( false );
    const { translations } = useContext( TranslationContext );
    const { validateForm } = useContext( ResumeContext );

    return (
        <div className="text-white">
            <div className="subtitre-cv-container text-underline d-flex align-items-center gap-2"
                 onClick={ () => setIsVisible( !isVisible ) }
                 style={ { cursor: "pointer" } }
            >
                <h4 className="text-underline pt-1 text-white">{ translations.languageSkillsSection.title }</h4> {/*translation.languagesSkillsSection.title[documentLanguage]*/ }
                <div className="line bg-white"></div>
                <MDBIcon
                    fas
                    icon={ "globe" }
                    style={ { color: "white" } }
                    size="lg"
                />
            </div>
            { isVisible && (
                <div className="text-white">
                    <LanguageSkillList/>
                    <AddLanguageSkill/>
                </div>
            ) }
        </div>
    );
}

